import { toast } from 'react-toastify';
import api from 'client';
import { useTranslation } from 'react-i18next';
import { fileDownload } from 'utils';

export default () => {
  const { t } = useTranslation('labels');
  const getLink = (invoiceId) => {
    api
      .get(`/apis/v2/patient/invoices/${invoiceId}/stripe_pay_link`, {})
      .then((response) => {
        if (response.status === 200) {
          window.open(response.data.url, '_blank');
        } else {
          toast.error(() => t('can_not_process_payment_link'));
        }
      })
      .catch((err) => {
        toast.error(() => err.message);
      });
  };

  const download = (invoiceId) => {
    api
      .get(`/apis/v2/patient/invoices/${invoiceId}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `invoice-${invoiceId}`, { newWindow: true, mime: response.headers['content-type'] });
      })
      .catch((err) => {
        toast.error(() => err.message);
      });
  };

  return {
    getLink,
    download,
  };
};
